module.exports = __webpack_public_path__ + "img/menucar.707cb20a.png";